<template>
    <vx-card title="Recovery Bin">
      <a-tabs @change="changeTab">
        <a-tab-pane key="1" tab="Contacts">
          <XTable :model="model_contact" ref="recoveryBinContact" class="mt-4 overflow-auto">
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item key="1" @click="openPromptRestoreContact(text.record)"><feather-icon icon="RefreshCcwIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Restore</a-menu-item>
                    </a-menu>
                    <a-button style="margin-left: 8px"> Actions <a-icon type="down" /></a-button>
                </a-dropdown>
            </span>
            <span slot="expandedRowRender" slot-scope="text,record">
              <a-descriptions bordered layout="vertical" :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
                <a-descriptions-item label="Emails">
                  <div v-for="item in text.text.emails">
                    <a-badge color="#3A3DBE" v-if="item.email_address" :text="item.email_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Websites">
                  <div v-for="item in text.text.websites">
                    <a-badge color="#3A3DBE" v-if="item.website_address" :text="item.website_address" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Phones">
                  <div v-for="item in text.text.phones">
                    <a-badge color="#3A3DBE" v-if="item.phone_number" :text="item.phone_number" />
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Addresses" :span="2">
                  <div v-for="(item,ind) in text.text.addresses">
                    <small class="font-bold" v-if="item.city">city:</small> {{ item.city }}
                    <br>
                    <small class="font-bold" v-if="item.post_code">postCode:</small> {{ item.post_code }}
                    <br>
                    <small class="font-bold" v-if="item.state">state:</small> {{ item.state }}
                    <br>
                    <small class="font-bold" v-if="item.street">street:</small> {{ item.street }}
                    <a-divider v-if="ind != text.text.addresses.length - 1"/>
                  </div>
                </a-descriptions-item>
              </a-descriptions>
          </span>
            <span slot="profile" slot-scope="text,record">
<!--<img v-if="text.record.avatar_url" :src="text.record.avatar_url" width="40" height="40" alt="" class="rounded-full object-cover" style="box-shadow:0 1px 3px -1px;">-->
<!--<img v-else :src="require('../../../public/profile.png')" width="40" height="40" class="rounded-full object-cover" alt="" style="box-shadow: 0 1px 3px -1px;">-->
              <a-avatar v-if="text.record.avatar_url" :src="text.record.avatar_url" />
              <a-avatar v-else icon="user" style="background:  #3A3DBE" />
            </span>
            <span slot="fullname" slot-scope="text,record">
                {{ text.record.person ? text.record.person.first_name + ' ' + text.record.person.last_name : text.record.company.name   }}
            </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Matters">
          <XTable :model="model" ref="recoveryBinMatter" class="mt-4 overflow-auto">
            <span slot="client" slot-scope="text,record">
              <template v-if="text.record.client.person">
                {{ text.record.client.person.first_name }}  {{ text.record.client.person.last_name }}
              </template>
              <template v-else>
                {{ text.record.client.company.name }}
              </template>
            </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                    <a-menu slot="overlay">
                      <a-menu-item key="1" @click="openPromptRestoreMatter(text.record)">
                        <feather-icon icon="RefreshCcwIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>
                        Restore
                      </a-menu-item>
                    </a-menu>
                    <a-button style="margin-left: 8px"> Actions <a-icon type="down" /></a-button>
                </a-dropdown>
         </span>
            <span slot="status" slot-scope="text,record">
            <template v-if="text.record.status === 1">
              Open
            </template>
            <template v-if="text.record.status === 2">
              Closed
            </template>
            <template v-if="text.record.status === 3">
              Pending
            </template>
          </span>
            <span slot="responsible" slot-scope="text,record" v-if="text.record.responsible">
              {{  text.record.responsible.first_name }}  {{  text.record.responsible.last_name }}
          </span>
            <span slot="origination" slot-scope="text,record" v-if="text.record.origination">
              {{  text.record.origination.first_name }}  {{  text.record.origination.last_name }}
          </span>
          </XTable>
        </a-tab-pane>
      </a-tabs>

      <deleteItem
        :url="`/matter/${item_restore}/restore/`"
        subject="Matter"
        :ele="$refs.recoveryBinMatter"
        :hasRestore="true"
        text-delete="Restore"
        ref="recoveryMatter"
      />

      <deleteItem
        :url="`/contact/${item_restore}/restore/`"
        subject="Contact"
        :ele="$refs.recoveryBinContact"
        :hasRestore="true"
        text-delete="Restore"
        ref="recoveryContact"
      />

    </vx-card>
</template>

<script>

    import * as TableCol from "./recoveryTblMatter";
    import * as TableColContact from "./recoveryTblContact";
    import XTable from "../../../../components/x-table/XTable";
    import deleteItem from '../../../communications/deleteItem'
    import axios from '@/axios'

    export default {
        name: "Recovery",
        components:{
          XTable,
          deleteItem
        },
        data(){
          return{
            model:null,
            model_contact:null,
            item_restore: null,
            show_prompt: false
          }
        },
        methods:{
          openPromptRestoreContact(record){
            this.$refs.recoveryContact.open = true
            this.item_restore = record.id
            this.show_prompt = true
          },
          openPromptRestoreMatter(record){
            this.$refs.recoveryMatter.open = true
            this.item_restore = record.id
            this.show_prompt = true
          },
          changeTab(key){
            if(key === '1'){
              this.$refs.recoveryBinContact.data = []
              this.$refs.recoveryBinContact.fetch()
            }else{
              this.$refs.recoveryBinMatter.data = []
              this.$refs.recoveryBinMatter.fetch()
            }
          },
          Restore(){
            axios.get('/dashboard/notification/')
          }
        },
        created() {
          this.model = TableCol.default
          this.model_contact = TableColContact.default
          this.Restore()
        }
    }
</script>

<style>
.ul-tabs.vs-tabs--ul.ul-tabs-left{
  z-index: 1;
}
</style>
